import { render, staticRenderFns } from "./ShortNovelWizard.vue?vue&type=template&id=01ded8d2&scoped=true"
import script from "./ShortNovelWizard.vue?vue&type=script&lang=js"
export * from "./ShortNovelWizard.vue?vue&type=script&lang=js"
import style0 from "./ShortNovelWizard.vue?vue&type=style&index=0&id=01ded8d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ded8d2",
  null
  
)

export default component.exports